var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.simple
        ? _c("div", { staticClass: "simpleLanguageSwitcher" }, [
            _vm.locale !== "de"
              ? _c("a", { attrs: { href: _vm.urlDe } }, [
                  _vm._v(_vm._s(_vm.$t("languageSwitcher.simple.german")))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.locale !== "en"
              ? _c("a", { attrs: { href: _vm.urlEn } }, [
                  _vm._v(_vm._s(_vm.$t("languageSwitcher.simple.english")))
                ])
              : _vm._e()
          ])
        : [
            _vm.locale !== "de"
              ? _c("a", { attrs: { href: _vm.urlDe } }, [
                  _vm._v(_vm._s(_vm.$t("languageSwitcher.german")))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.locale !== "en"
              ? _c("a", { attrs: { href: _vm.urlEn } }, [
                  _vm._v(_vm._s(_vm.$t("languageSwitcher.english")))
                ])
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }